import { CONNECT_STATIC_MACRO_SSR_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';

export type ConnectStaticMacroSSRData = {
	contentId?: string;
	extensionKey?: string;
	macroId?: string;
	isConnectMacro?: boolean;
};

const safelyTrackConnectStaticMacroSSRExperience = (track: () => void): void => {
	try {
		track();
	} catch {
		// Telemetry must never block or alter macro rendering behaviour.
	}
};

export const ConnectStaticMacroSSRExperienceTrackerSupport: {
	isTrackable(data: ConnectStaticMacroSSRData | null | undefined): boolean;
	start(data: ConnectStaticMacroSSRData | null | undefined): void;
	succeed(): void;
	fail(error: Error): void;
	abort(reason: string): void;
} = new (class ConnectStaticMacroSSRExperienceTrackerSupport {
	isTrackable(data: ConnectStaticMacroSSRData | null | undefined): boolean {
		return (
			Boolean(data?.contentId) &&
			Boolean(data?.extensionKey) &&
			Boolean(data?.macroId) &&
			Boolean(data?.isConnectMacro)
		);
	}

	start(data: ConnectStaticMacroSSRData | null | undefined): void {
		safelyTrackConnectStaticMacroSSRExperience(() => {
			getExperienceTracker().start({
				name: CONNECT_STATIC_MACRO_SSR_EXPERIENCE,
				attributes: {
					contentId: data?.contentId,
					extensionKey: data?.extensionKey,
					macroId: data?.macroId,
				},
			});
		});
	}

	succeed(): void {
		safelyTrackConnectStaticMacroSSRExperience(() => {
			getExperienceTracker().succeed({
				name: CONNECT_STATIC_MACRO_SSR_EXPERIENCE,
			});
		});
	}

	fail(error: Error): void {
		safelyTrackConnectStaticMacroSSRExperience(() => {
			getExperienceTracker().fail({
				name: CONNECT_STATIC_MACRO_SSR_EXPERIENCE,
				error,
			});
		});
	}

	abort(reason: string): void {
		safelyTrackConnectStaticMacroSSRExperience(() => {
			getExperienceTracker().abort({
				name: CONNECT_STATIC_MACRO_SSR_EXPERIENCE,
				reason,
			});
		});
	}
})();
